module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("灰度设置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所有学生"
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.allEnabled === 1,
      "size": "large",
      "disabled": _vm.saving
    },
    on: {
      "on-change": _vm.onAllChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])])], 1), _vm._v(" "), (_vm.allEnabled === 1) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("全量已开，名单不参与判定")]) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.addAdviser
    }
  }, [_vm._v("添加学导")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "销售"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.sellerId),
      callback: function($$v) {
        _vm.sellerId = $$v
      },
      expression: "sellerId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.addSeller
    }
  }, [_vm._v("添加销售")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID或手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入学生 uid 或手机号"
    },
    model: {
      value: (_vm.studentKeyword),
      callback: function($$v) {
        _vm.studentKeyword = $$v
      },
      expression: "studentKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.addStudent
    }
  }, [_vm._v("添加学生")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "mex-gray-title"
  }, [_vm._v("学导")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.ruleColumns,
      "data": _vm.advisers,
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "mex-gray-title"
  }, [_vm._v("销售")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.ruleColumns,
      "data": _vm.sellers,
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "mex-gray-title"
  }, [_vm._v("指定学生")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.ruleColumns,
      "data": _vm.students,
      "size": "small"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-156a3cbf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexGraySetting.vue
// module id = 1637
// module chunks = 8